import { zodResolver } from '@hookform/resolvers/zod';
import { useMemo } from 'react';
import { z } from 'zod';

import { stepToSchemaMap } from '../constants/schemas';
import { useWizardActiveStep } from './useWizardActiveStep';

export const useWizardFormResolver = () => {
    const activeStep = useWizardActiveStep();

    const schema = useMemo(() => {
        if (!activeStep) {
            return z.object({}).passthrough();
        }

        return stepToSchemaMap[activeStep];
    }, [activeStep]);

    return { resolver: zodResolver(schema) };
};
